import { AuthGuard } from '../auth/AuthGuard';
import { DemographicQuestionsScreen } from './DemographicQuestionsScreen';

// render Demographic Questions
export const DemographicQuestions = ({ authPath, surveyQuestionsPath }) => (
  <AuthGuard authPath={authPath}>
    <DemographicQuestionsScreen surveyQuestionsPath={surveyQuestionsPath} />
  </AuthGuard>
);
